<template>
  <div class="home">
    <Topbar class="topbar" />
    <Layout />
  </div>
</template>

<script>
// @ is an alias to /src
import Topbar from '../components/Topbar.vue';
import Layout from '../components/Layout.vue';

export default {
  name: 'home',
  components: {
    Layout,
    Topbar
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
.home {
  @include gradient(#ffffff, #d3d3d3, 155);
}
</style>
